import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialAuthState {
  accessToken: string | null;
  patientFhirId: string | null;
  tokenExpiry: number | null;
}

const initialState: InitialAuthState = {
  accessToken: null,
  patientFhirId: null,
  tokenExpiry: null,
};

const patientAuthSlice = createSlice({
  name: "patientAuth",
  initialState,
  reducers: {
    setPatientAuthToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    setPatientFhirId(state, action: PayloadAction<string>) {
      state.patientFhirId = action.payload;
    },
    setTokenExpiry(state, action: PayloadAction<number>) {
      state.tokenExpiry = action.payload;
    },
    clearUser(state) {
      state.patientFhirId = null;
      state.accessToken = null;
      state.tokenExpiry = null;
    },
  },
});

export const patientAuthSliceActions = patientAuthSlice.actions;
export default patientAuthSlice.reducer;
